<div class="sx-system-message__container sxl-flex sxl-column" *ngIf="preClosureMessage.isVisible || startPageBanner.isVisible || messages.length > 0">
  <app-system-message  *ngIf="preClosureMessage" 
      [ngClass]="{'sx-system-message__notLoggedIn': !isLoggedIn}"
      [id]="preClosureMessage.id"
      [isVisible]="preClosureMessage.isVisible" 
      [severity]="preClosureMessage.severity" 
      [icon]="preClosureMessage.icon" 
      [isDismissable]="isLoggedIn" 
      (messageDismissed)="onMessageDismissed($event)">
      
      <div [innerHtml]="preClosureMessage.content | safeHtml"></div>
  </app-system-message>

  <app-system-message *ngIf="!isLoggedIn && startPageBanner" 
      [ngClass]="{'sx-system-message__notLoggedIn': !isLoggedIn}"
      [id]="startPageBanner.id"
      [isVisible]="startPageBanner.isVisible" 
      [severity]="startPageBanner.severity" 
      [icon]="startPageBanner.icon" 
      [isDismissable]="false" 
      (messageDismissed)="onMessageDismissed($event)">
  
      <div [innerHtml]="startPageBanner.content | safeHtml"></div>
  </app-system-message>

  <ng-container *ngIf="isLoggedIn" >
    <span [ngClass]="{'sx-system-message__container-list': !allMessagesDismissed}">
    <app-system-message *ngFor="let message of messages" 
        [id]="message.id"
        [isVisible]="message.isVisible" 
        [severity]="message.severity" 
        [icon]="message.icon" 
        [isDismissable]="true"
        (messageDismissed)="onMessageDismissed($event)">
      
        <div [innerHtml]="message.content | safeHtml"></div>
    </app-system-message>
    </span>
  </ng-container>
</div>
